import React from 'react';
import { ALL_PROPERTY_FACILITIES } from '../../lib/constants';
import { cn } from '../../lib/utils';
interface StepFacilitiesProps {
  selected: string[];
  onChange: (selected: string[]) => void;
  tenantWishlist?: {
    locations: string[];
    essentials: string[];
    preferred: string[];
  };
  tenantName?: string;
}
export function StepFacilities({
  selected,
  onChange,
  tenantWishlist,
  tenantName
}: StepFacilitiesProps) {
  const selectedSet = new Set(selected);
  const toggle = (val: string) => {
    if (selectedSet.has(val)) onChange(selected.filter(s => s !== val));else onChange([...selected, val]);
  };
  const wishlistAll = tenantWishlist ? [...tenantWishlist.locations, ...tenantWishlist.essentials, ...tenantWishlist.preferred] : [];
  const wishlistMatched = wishlistAll.filter(w => selectedSet.has(w)).length;
  // In offer mode, we count how many of the tenant's wishlist items the
  // landlord has matched. The "minim 3" nudge is now tied to the wishlist
  // itself rather than a generic catalog threshold.
  const wishlistEssentialMatched = tenantWishlist ? tenantWishlist.essentials.filter(e => selectedSet.has(e)).length : 0;
  const hasTenantContext = !!tenantWishlist && wishlistAll.length > 0;
  return <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 space-y-6" data-id="element-2493">
      <div data-id="element-2494">
        <h2 className="text-2xl sm:text-3xl font-bold text-light-1 mb-2" data-id="element-2495">
          Ce oferă proprietatea?
        </h2>
        <p className="text-sm text-light-3" data-id="element-2496">
          Bifează tot ce are. Chiriașii decid singuri ce e esențial pentru ei.
        </p>
      </div>

      {hasTenantContext && <div className="rounded-xl bg-dark-2 border border-dark-4 px-4 py-3" data-id="element-2497">
          <div className="flex items-baseline justify-between gap-2 mb-2" data-id="element-2498">
            <p className="text-xs font-medium text-light-3 uppercase tracking-wider" data-id="element-2499">
              Potrivire cu cererea
            </p>
            <p className="text-xs text-light-1" data-id="element-2500">
              <span className={cn('font-semibold', wishlistMatched > 0 && 'text-lime-1')} data-id="element-2501">
                {wishlistMatched}
              </span>{' '}
              <span className="text-light-3" data-id="element-2502">
                din {wishlistAll.length} dorite
                {tenantName ? ` de ${tenantName}` : ''}
              </span>
            </p>
          </div>
          <div className="h-1.5 rounded-full bg-dark-4 overflow-hidden" role="progressbar" aria-valuenow={wishlistMatched} aria-valuemin={0} aria-valuemax={wishlistAll.length} data-id="element-2503">
            <div className="h-full bg-lime-1 transition-all duration-300" style={{
          width: `${wishlistMatched / wishlistAll.length * 100}%`
        }} data-id="element-2504" />
          </div>
        </div>}

      <div className="flex items-baseline justify-between text-xs" data-id="element-2505">
        <span className="font-medium text-light-3 uppercase tracking-wider" data-id="element-2506">
          {selected.length > 0 ? `${selected.length} facilități selectate` : 'Selectează facilitățile'}
        </span>
        {hasTenantContext && tenantWishlist!.essentials.length > 0 && <span className={cn('text-light-3', wishlistEssentialMatched >= 3 && 'text-lime-1')} data-id="element-2507">
            minim 3 din cele dorite
            {tenantName ? ` de ${tenantName}` : ''}
          </span>}
      </div>

      <div className="flex flex-wrap gap-2" data-id="element-2508">
        {ALL_PROPERTY_FACILITIES.map(opt => {
        const isSelected = selectedSet.has(opt);
        const isWanted = wishlistAll.includes(opt);
        return <button key={opt} type="button" onClick={() => toggle(opt)} className={cn('inline-flex items-center h-10 px-4 rounded-full text-sm font-normal border transition-colors cursor-pointer', isSelected ? 'bg-lime-1 text-dark-1 border-lime-1' : isWanted ? 'bg-dark-2 border-lime-4 text-light-1 hover:border-lime-3' : 'bg-dark-2 border-dark-4 text-light-2 hover:border-light-3')} data-id="element-2509">
              {opt}
            </button>;
      })}
      </div>
    </div>;
}